'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.groupBy = exports.shuffle = exports.arrayDiff = exports.uniqueValues = void 0;
function uniqueValues(array) {
    return Array.from(new Set(array).values());
}
exports.uniqueValues = uniqueValues;
/**
 * Creates an array of array values not included in the second given array
 * @param arr
 * @param arr2
 */
function arrayDiff(arr, arr2) {
    return arr.filter(function (i) { return arr2.indexOf(i) < 0; });
}
exports.arrayDiff = arrayDiff;
/**
 * Shuffles an array
 * @param arr
 */
function shuffle(arr) {
    var array = arr.slice();
    var m = array.length;
    var t;
    var i;
    while (m) {
        i = Math.floor(Math.random() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }
    return array;
}
exports.shuffle = shuffle;
/**
 * Groups an array based on a particular key and merges
 * all the properties in the grouped output that are not
 * falsy.
 *
 * @param arr The array to group
 * @param key A key of an object in the array
 */
function groupBy(arr, key) {
    var map = new Map();
    arr.forEach(function (item) {
        var collection = map.get(key);
        if (!collection) {
            map.set(item[key], [item]);
        }
        else {
            collection.push(item);
        }
    });
    // Output an array of all the map's values
    return Array.from(map.values()).reduce(function (acc, curr) {
        // Merge the grouped values together
        acc.push(curr.reduce(function (merged, latest) {
            // Only set the value if it exists on latest
            for (var _i = 0, _a = Object.keys(latest); _i < _a.length; _i++) {
                var subKey = _a[_i];
                var value = latest[subKey];
                if (value) {
                    merged[subKey] = value;
                }
            }
            return merged;
        }, Object.assign({}, curr[0])));
        return acc;
    }, []);
}
exports.groupBy = groupBy;
